import styles from "./part5.module.scss";
const YTPlayer = require("yt-player");
import { useEffect } from "react";

export default function HomePart2() {
  useEffect(() => {
    const player = new YTPlayer("#player", {
      width: 562,
      height: 316,
    });
    player.load("fHgnqbB8kTE");
    player.setVolume(100);
    player.on("playing", () => {
      console.log(player.getDuration()); // => 351.521
    });

    return () => {};
  }, []);
  return (
    <div className={styles.part5 + " main"}>
      <div className={styles.inner}>
        <div className={styles.left}>
          <img src="/img/dingtone.png" alt="dingtone logo" />
          <p>
            Founded in 2012, Dingtone has become a renowned phone services
            provider that helps people stay connected and lower phone bills with
            its reliable services. The company currently serves more than 100
            million users worldwide.
          </p>
        </div>
        <div className={styles.right}>
          <div id="player"></div>
        </div>
      </div>
    </div>
  );
}
